import { getUpcomingMeteorShowers } from '../data/meteors';

/**
 * Renders the Meteor showers panel into the given container.
 */
export function renderMeteorsCard(container: HTMLElement): void {
  const showers = getUpcomingMeteorShowers(5);
  const panel = document.createElement('div');
  panel.className = 'panel';
  panel.innerHTML = `
    <div class="panel-title">☄️ Meteor showers</div>
    <p class="panel-content threat-subtext">Upcoming peaks from a curated annual list. ZHR is the zenithal hourly rate — meteors per hour under a dark sky with the radiant overhead. Real counts are usually lower; the hours before dawn are often best.</p>
    <ul class="event-list panel-content">
      ${showers
        .map(
          (s) => `
        <li>
          <span class="event-name">${s.name}</span>
          <span class="event-date">${s.peakLabel}${s.zhr ? ` · ZHR ${s.zhr}` : ''}</span>
          ${s.note ? `<span class="badge">${s.note}</span>` : ''}
        </li>
      `
        )
        .join('')}
    </ul>
  `;
  container.appendChild(panel);
}
